import { OnInit, Component, transition, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup } from '@angular/forms';

import { NgbModal, NgbActiveModal, NgbTabChangeEvent } from '@ng-bootstrap/ng-bootstrap';
import { Observable } from 'rxjs/Observable';
import * as _ from 'lodash';

import { LoadingService } from '@shared/modules/loading';
import { AlertService } from '@shared/modules/alert';

import { FADE_IN_OUT_ANIMATION } from '@shared/animations';
import { InputImageEvent } from '@shared/modules/input-image';
import { ParseObject, Language, FileRef, Offer } from '@shared/data';
import { CrudService, LanguageService } from '@shared/services';
import { OfferQuery } from '@shared/queries';

@Component({
  moduleId: 'module.id',
  selector: 'edit-offer',
  styles: [require('./edit-offer.component.scss')],
  template: require('./edit-offer.component.html'),
  animations: [FADE_IN_OUT_ANIMATION]
})
export class EditOfferComponent implements OnInit, OnDestroy {
  public formCtrl: FormGroup;

  public languages: Observable<Language[]>;
  public lang: string;
  public offer: Offer;

  public error: Parse.Error;
  public offerId: string;
  public isSaving: boolean;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private loadingService: LoadingService,
    private modalService: NgbModal,
    private crudService: CrudService,
    private alertService: AlertService,
    public languageService: LanguageService) {

    this.offer = new Offer();
    this.languages = this.languageService.find().publishReplay(1).refCount();
    this.lang = this.languageService.defaultLang;
  }

  public ngOnInit(): void {
    this.route.params.subscribe((params) => {
      this.offerId = params['id'];

      if (!this.offerId) {
        return;
      }

      this.fetchOffer();
    });
  }

  public ngOnDestroy(): void {
    this.offer.revert();
  }

  // ===============================================================================================
  // Accessors
  // ===============================================================================================

  public get isValid() {
    return this.offer.getTitle(this.lang);
  }

  public get parentUrl(): string {
    return this.offerId ? '../../' : '../';
  }

  // ===============================================================================================
  // Actions
  // ===============================================================================================

  public onSave(): void {
    this.isSaving = true;
    this.loadingService.continue();

    this.offer.save().then(
      result => {
        this.isSaving = false;
        this.loadingService.complete();
      },
      error => {
        this.error = error;
        this.isSaving = false;
        this.loadingService.complete();
      }
    );
  }

  public onIconChange(event: InputImageEvent): void {
    let image = this.offer.getIcon(this.lang) || new FileRef();

    image.setFile(event.file);

    this.offer.setIcon(image, this.lang);
  }

  public onIconSelect(event: FileRef) {
    this.offer.setIcon(event, this.lang);
  }

  public onImageChange(event: InputImageEvent): void {
    let image = this.offer.getImage(this.lang) || new FileRef();

    image.setFile(event.file);

    this.offer.setImage(image, this.lang);
  }

  public onImageSelect(event: FileRef) {
    this.offer.setImage(event, this.lang);
  }

  public onTabChange(evt: NgbTabChangeEvent) {
    this.lang = evt.nextId;

    if (this.offerId) {
      this.fetchOffer();
    }
  }

  // ===============================================================================================
  // Private Methods
  // ===============================================================================================

  private fetchOffer(): void {
    let query = new OfferQuery()
      .includeTranslation(Offer.ICON_KEY, this.lang)
      .includeTranslation(Offer.IMAGE_KEY, this.lang);

    this.loadingService.continue();

    query.get(this.offerId).then(
      result => {
        this.offer = result;
        this.loadingService.complete();
      },
      error => {
        this.error = error;
        this.loadingService.complete();
      }
    );
  }
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/+admin/modules/+offer/edit-offer/edit-offer.component.ts